import { Alert } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const clientAdminAllStationsAccessMessage = defineMessage({
  id: 'admin.users.viewScreen.permissions.clientAdminAllStationsAccess',
  defaultMessage: 'Los usuarios administradores tienen acceso a todas las emisoras por defecto.',
});

/**
 * Explains that CLIENT_ADMIN users inherit access to every station, so per-station
 * permission toggles are not applicable.
 */
export function ClientAdminAllStationsAccessAlert() {
  return (
    <Alert severity="info">
      <FormattedMessage {...clientAdminAllStationsAccessMessage} />
    </Alert>
  );
}
